//src/app/features/auth/signUp/step-one/formFields.ts
import { passwordValidation } from 'Components/Auth/PasswordInput';
import { Validators } from 'utils/Validators';
import * as Yup from 'yup';

export type FormFieldsOne = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  signupEmail: string;
  signupPassword: string;
  address: string; // New Field
  zipcode: string;
  city: string;
  time_zone_id?: string;
  language_id?: string;
  terms: boolean;
  showEmail: boolean;
};

export const initialData: FormFieldsOne = {
  firstName: '',
  lastName: '',
  signupEmail: '',
  phoneNumber: '',
  language_id: '37', //equivalent to EN on database backend
  time_zone_id: '16', //equivalent to EST on database backend
  address: 'N/A',
  zipcode: '00000',
  city: 'N/A',
  signupPassword: '',
  terms: false,
  showEmail: true,
};

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('required'),
  lastName: Yup.string().trim().required('required'),
  phoneNumber: Yup.string()
    .trim()
    .when('showEmail', {
      is: true,
      then: Yup.string().trim(),
      otherwise: Yup.string().trim().required('required'),
    }),
  signupEmail: Yup.string()
    .trim()
    .when('showEmail', {
      is: true,
      then: Yup.string().trim().email().required('required'),
      otherwise: Yup.string().trim(),
    }),
  signupPassword: passwordValidation,
  address: Yup.string().trim(),
  zipcode: Validators.zipCode,
  city: Yup.string().trim(),
  time_zone_id: Yup.string().trim(),
  language_id: Yup.string().trim(),
  terms: Yup.bool().oneOf([true], 'required'),
});
